// extracted by mini-css-extract-plugin
export default {"skeleton":"JRubmU0rzRHRwJBBmdqL","headerBar":"_KCkdaovgMdr3R79qyPk"};